module.exports = __webpack_public_path__ + "img/bx-3.48f7518f.jpg";